let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("4v21d")).then(() => parcelRequire('4OrDw'));